<ng-template #newCollTreeTemplate style="background-color:burlywood">
  <div class="modal-header headerBackground">
    <h4 class="modal-title pull-left ">New TreeCollection</h4>
    <button type="button " class="close pull-right" aria-label="Close" (click)="modalRef.hide();">
      <span aria-hidden="true ">&times;</span>
    </button>
  </div>
  <div class="row padding-1">
      <div class="form-group col-md-6 padding-top">
        <div class="input-group input-group-sm mb-2">
          <div class="input-group-prepend">
            <span class="input-group-text">*</span>
          </div>
          <input type="text" class="form-control" #coll/>
        </div>
        <button type="button" class="btn-sm" (click)="newTreeCollection(coll.value);modalRef.hide()" class="btn btn-warning btn-sm">Save new TreeCollection</button>
    </div>
  </div>
</ng-template>
    